import React from 'react';
import LocationTemplate from './LocationTemplate';

const MomeyerPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Momeyer"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27858"]}
      latitude={35.9355}
      longitude={-77.9744}
      population={220}
      historicalFact="Incorporated in 1907, small town in Nash County."
      nearbyTowns={[
        "Nashville, NC",
        "Rocky Mount, NC",
        "Red Oak, NC",
        "Spring Hope, NC",
        "Castalia, NC",
        "Bailey, NC",
        "Elm City, NC",
        "Dortches, NC"
      ]}
    />
  );
};

export default MomeyerPage;